import styled, {css, keyframes} from "styled-components";
import LoopImage from "../img/figures/loop/proxies-cycle-only.png";
import { useState, useEffect } from "react";


const timeInterval = 1000;
const rotationIncrement = 45;


const TracingLoopContainer = styled.div`
    width: 100%;
    position: relative;
    aspect-ratio: 1 / 1;
`;

const LoopLayer = styled.img`
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    opacity: 0;
    mix-blend-mode: multiply;

    transition: transform ${timeInterval * 2 / 1000}s, opacity ${timeInterval * 2 / 1000}s;
    transition-timing-function: ease-out;

    &.base-layer {
        opacity: 1;
        transform: rotate(0deg)scale(0.5);
    }

    &.exit {
        opacity: 0;
    }

`;

const Loop1 = styled(LoopLayer)`

    transform: translate(5px, 5px)rotate(${0 * rotationIncrement}deg)scale(0.52);


    &.enter {
        transform: translate(5px, 5px)rotate(${1 * rotationIncrement}deg)scale(0.52);
        opacity: 1;
    }

`;

const Loop2 = styled(LoopLayer)`

    transform: translate(-5px, 5px)rotate(${1 * rotationIncrement}deg)scale(0.54);

    &.enter {
        transform: translate(-5px, 5px)rotate(${2 * rotationIncrement}deg)scale(0.54);
        opacity: 0.9;
    }

`;

const Loop3 = styled(LoopLayer)`

    transform: translate(10px, 10px)rotate(${2 * rotationIncrement}deg)scale(0.56);

    &.enter {
        transform: translate(10px, 10px)rotate(${3 * rotationIncrement}deg)scale(0.56);
        opacity: 0.8;
    }

`;

const Loop4 = styled(LoopLayer)`

    transform: translate(-10px, -20px)rotate(${3 * rotationIncrement}deg)scale(0.58);

    &.enter {
        transform: translate(-10px, -20px)rotate(${4 * rotationIncrement}deg)scale(0.58);
        opacity: 0.7;
    }

`;


const Loop5 = styled(LoopLayer)`

    transform: translate(30px, 15px)rotate(${4 * rotationIncrement}deg)scale(0.60);

    &.enter {
        transform: translate(30px, 15px)rotate(${5 * rotationIncrement}deg)scale(0.60);
        opacity: 0.6;
    }

`;

const Loop6 = styled(LoopLayer)`

    transform: translate(20px, -30px)rotate(${5 * rotationIncrement}deg)scale(0.62);

    &.enter {
        transform: translate(20px, -30px)rotate(${6 * rotationIncrement}deg)scale(0.62);
        opacity: 0.5;
    }

`;

const Loop7 = styled(LoopLayer)`

    transform: translate(-20px, 20px)rotate(${6 * rotationIncrement}deg)scale(0.64);

    &.enter {
        transform: translate(-20px, 20px)rotate(${7 * rotationIncrement}deg)scale(0.64);
        opacity: 0.4;
    }

`;

const Loop8 = styled(LoopLayer)`

    transform: translate(-10px, -10px)rotate(${7 * rotationIncrement}deg)scale(0.66);

    &.enter {
        transform: translate(-10px, -10px)rotate(${8 * rotationIncrement}deg)scale(0.66);
        opacity: 0.3;
    }

`;

const Loop9 = styled(LoopLayer)`

    transform: rotate(${8 * rotationIncrement}deg)scale(0.68);

    &.enter {
        transform: rotate(${9 * rotationIncrement}deg)scale(0.68);
        opacity: 0.2;
    }

`;

const Loop10 = styled(LoopLayer)`

    transform: rotate(${9 * rotationIncrement}deg)scale(0.75);

    &.enter {
        transform: rotate(${10 * rotationIncrement}deg)scale(0.75);
        opacity: 0.1;
    }

`;


const imageCount = 10;

const TracingLoop = () => {


    const [imageIndex, setImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {

            setImageIndex(currentImageIndex => currentImageIndex + 1);

        }, timeInterval);
        return () => clearInterval(interval);
    }, []);


    return <TracingLoopContainer>
        <LoopLayer src={LoopImage} className="base-layer" />
        <Loop1 src={LoopImage} className={1 > imageIndex % (imageCount + 1) ? "exit" : "enter"} />
        <Loop2 src={LoopImage} className={2 > imageIndex % (imageCount + 1) ? "exit" : "enter"} />
        <Loop3 src={LoopImage} className={3 > imageIndex % (imageCount + 1) ? "exit" : "enter"} />
        <Loop4 src={LoopImage} className={4 > imageIndex % (imageCount + 1) ? "exit" : "enter"} />
        <Loop5 src={LoopImage} className={5 > imageIndex % (imageCount + 1) ? "exit" : "enter"} />
        <Loop6 src={LoopImage} className={6 > imageIndex % (imageCount + 1) ? "exit" : "enter"} />
        <Loop7 src={LoopImage} className={7 > imageIndex % (imageCount + 1) ? "exit" : "enter"} />
        <Loop8 src={LoopImage} className={8 > imageIndex % (imageCount + 1) ? "exit" : "enter"} />
        <Loop9 src={LoopImage} className={9 > imageIndex % (imageCount + 1) ? "exit" : "enter"} />
        <Loop10 src={LoopImage} className={10 > imageIndex % (imageCount + 1) ? "exit" : "enter"} />
    </TracingLoopContainer>

}

export default TracingLoop;